import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {CREATE_VALET, TAG_CREATION, TAG_LIST, UPDATE_VALET_STATUS} from "./type";

/**
 *
 * @param requestParams
 * @returns {(function(*): Promise<AxiosResponse<any>|void|*|boolean|undefined>)|*}
 */
export const createValet = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            {
                'phone_number': requestParams.phone_no,
                'first_name': requestParams.first_name,
                'last_name': requestParams.last_name,
                'project_id': requestParams.project_id,
                'pan_card': requestParams.pan_card,
                'driving_licence': requestParams.driving_licence,
                'adhar_card': requestParams.adhar_card,
                'type': requestParams.type,
                'profile': requestParams.profile
            },
            `${Config.valet.addValet}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: CREATE_VALET,
                payload: data,
            });
            return res;
        }
    }
    catch {
        dispatch({
            type: CREATE_VALET,
            payload: null,
        });
        return true;
    }
}

/**
 *
 * @param data
 * @returns {boolean|Promise<AxiosResponse<any>|void>|*}
 */
export const updateValetStatus = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            {
                'project_id': data.project_id,
                'user_id': data.user_id,
            },
            `${Config.valet.updateValetStatus}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: UPDATE_VALET_STATUS,
                payload: data,
            });
            return res;
        }
    }
    catch {
        dispatch({
            type: UPDATE_VALET_STATUS,
            payload: null,
        });
        return true;
    }
}


export const createTag = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            requestParams,
            `${Config.valet.tagCreation}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: TAG_CREATION,
                payload: data,
            });
            return res;
        }
    }
    catch {
        dispatch({
            type: TAG_CREATION,
            payload: null,
        });
        return true;
    }
}

export const tagList = (projectId) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.valet.tagList}?project_id=${projectId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: TAG_LIST,
                payload: data?.response.data,
            });
            return res;
        }
    }
    catch {
        dispatch({
            type: TAG_LIST,
            payload: null,
        });
        return true;
    }
}